var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 34,
    width: 34,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m17 34c-9.373 0-17-7.627-17-17s7.627-17 17-17 17 7.627 17 17-7.627 17-17 17zm4.7-14.471a3.169 3.169 0 0 1 -1.48 2.69l-1.99 1.26c-2.408 1.528-3.419 3.147-3.09 4.949.17.926.552 1.538 1.174 1.874.436.235 1.01.353 1.706.353.438 0 .923-.05 1.444-.143 7.45-1.36 12.405-8.528 11.048-15.978-1.192-6.532-6.869-11.272-13.496-11.272-.828 0-1.662.076-2.482.226a13.647 13.647 0 0 0 -8.832 5.702 13.642 13.642 0 0 0 -2.214 10.276 13.66 13.66 0 0 0 1.72 4.584c.111-3.85 2.48-7.267 7.05-10.167l9.442-5.983v2.108a3.166 3.166 0 0 1 -1.48 2.69c-2.12 1.342-4.588 2.907-6.214 3.938-4.26 2.703-6.03 5.64-5.42 8.988.338 1.852 1.15 3.081 2.477 3.763.347.166.705.32 1.067.459a7.937 7.937 0 0 1 -.201-.832c-.731-4.003 2.073-6.717 4.55-8.289 1.046-.664 2.652-1.681 3.998-2.531l1.22-.774v2.109z",
    fill: "#01b682",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d076e9af9656312d35747a028caeb5a2.svg";
export { ForwardRef as ReactComponent };